import { rankingItems } from '@/pages/home/mocks/data';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3">
            热度排行
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">八卦热度榜</h2>
          <p className="text-foreground-500 mt-2 text-sm">根据阅读量、讨论度和分享数综合排名</p>
        </div>

        <div className="space-y-2">
          {rankingItems.map((item, idx) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center text-sm font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank === 1 ? (
                  <i className="ri-vip-crown-fill text-lg"></i>
                ) : item.rank === 2 ? (
                  <i className="ri-vip-crown-line text-lg"></i>
                ) : item.rank === 3 ? (
                  <i className="ri-award-line text-lg"></i>
                ) : item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-sm text-foreground-800 font-medium truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </span>
                  {item.isNew && (
                    <span className="flex-shrink-0 px-1.5 py-0.5 bg-primary-100 text-primary-600 text-[10px] font-bold rounded whitespace-nowrap">NEW</span>
                  )}
                </div>
                <span className="text-xs text-foreground-500">{item.heat} 热度</span>
              </div>
              <div className="flex-shrink-0">
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-line text-green-500 text-lg"></i>
                ) : (
                  <i className="ri-arrow-down-line text-red-400 text-lg"></i>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}